import { CopyIcon } from "./DynamicCopyIcon";
import mentionIcon from "../../assets/mention_icon.svg";
import { Button, Tooltip } from "antd";
import { useCallback, useState } from "react";
import { sentimentClass } from "../../redux/constants/enums";
import CopyToClipboard from "react-copy-to-clipboard";
import { ChatIcon } from "./DynamicChatIcon";
import { useSelector } from "react-redux";

export const MentionIdComponent = ({
  id,
  color = "var(--locobuzz-text-color)",
  right,
  backgroudColor,
  top,
  className = "",
  type,
  trendView = false,
  postCardDetails,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const [copy, setCopy] = useState(false);
  const sentimentColor = {
    Neutral: "#F0C52F",
    Negative: "#FF5D48",
    Positive: "#5ED142",
  };

  const onCopy = useCallback(() => {
    setCopy(true);
  }, []);

  if (personalizationSettingsObj?.isPersonalizationPreviewOpen || !id) {
    return;
  } else {
    return (
      <div
        className={`${className ? className : "mention-id-component-parent"}`}
        style={{
          right: authParams?.screen_id === "000-000-554" ? "0" : "15px",
          top: authParams?.screen_id === "000-000-554" ? "-24px" : "6px",
        }}
      >
        <div
          className={`${
            type === "news-card" ? "font-size14" : "font-size12"
          } d-flex align-items-center mention-id-component text-grayLight ${
            sentimentClass[color] || "default-text-color"
          } ${
            authParams?.screen_id === "000-000-561"
              ? "mention-id-component-bg-postgal"
              : authParams?.screen_id && authParams?.screen_id !== "000-000-565"
              ? "mention-id-component-bg-cc"
              : ""
          }`}
          style={{
            backgroundColor:
              authParams?.screen_id === "000-000-565" && !trendView
                ? color === "Positive"
                  ? "var(--locobuzz-mention-sentiment-positive-mendash) !important"
                  : color === "Negative"
                  ? "var(--locobuzz-mention-sentiment-negative-mendash) !important"
                  : color === "Neutral"
                  ? "var(--locobuzz-mention-sentiment-neutral-mendash) !important"
                  : ""
                : authParams?.screen_id === "000-000-554"
                ? "var(--locobuzz-cc-widget-header-bg-color) !important"
                : "",
          }}
        >
          {/* <img src={mentionIcon} alt="message-icon" /> */}
          <ChatIcon
            color={
              authParams?.screen_id === "000-000-561"
                ? "var(--locobuzz-primary-text-color)"
                : authParams?.screen_id === "000-000-565"
                ? trendView
                  ? "var(--locobuzz-primary-text-color)"
                  : "var(--locobuzz-secondary-text-color)"
                : authParams?.screen_id === "000-000-554"
                ? "var(--locobuzz-primary-text-color)"
                : authParams?.screen_id
                ? "var(--locobuzz-secondary-text-color)"
                : "var(--locobuzz-primary-text-color)"
            }
            width={
              authParams?.screen_id === "000-000-561" &&
              !trendView &&
              !postCardDetails
                ? "30px"
                : ""
            }
            height={
              authParams?.screen_id === "000-000-561" &&
              !trendView &&
              !postCardDetails
                ? "30px"
                : ""
            }
          />
          <span
            className={`default-text-color ${
              authParams?.screen_id === "000-000-565"
                ? trendView
                  ? "mention-text-color-trend"
                  : "mention-text-color-mendash"
                : authParams?.screen_id === "000-000-561"
                ? "mention-text-color-postgal"
                : authParams?.screen_id === "000-000-554"
                ? "mention-text-color-trend"
                : authParams?.screen_id &&
                  authParams?.screen_id !== "000-000-561"
                ? "default-text-color-cc"
                : ""
            } `}
            style={{
              fontSize:
                authParams?.screen_id === "000-000-561" &&
                !trendView &&
                !postCardDetails
                  ? "var(--font-size-large-xxx)"
                  : "",
            }}
          >
            {id}
          </span>
          <Tooltip
            title={copy ? "Copied" : "Copy mention Id"}
            onVisibleChange={() => setCopy(false)}
          >
            <CopyToClipboard
              disabled={id ? false : true}
              text={id}
              onCopy={onCopy}
              style={{
                cursor: "pointer",
                background: "none",
                border: "none",
                outline: "none",
              }}
            >
              <button>
                <CopyIcon
                  color={
                    authParams?.screen_id === "000-000-565" && !trendView
                      ? "var(--locobuzz-secondary-text-color)"
                      : sentimentColor[color] ||
                        "var(--locobuzz-primary-text-color)"
                  }
                  width={
                    authParams?.screen_id === "000-000-561" &&
                    !trendView &&
                    !postCardDetails
                      ? "30px"
                      : ""
                  }
                  height={
                    authParams?.screen_id === "000-000-561" &&
                    !trendView &&
                    !postCardDetails
                      ? "30px"
                      : ""
                  }
                />
              </button>
            </CopyToClipboard>
          </Tooltip>
        </div>
      </div>
    );
  }
};
